// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ad96c25","453":"26444360","455":"328d82f6","977":"dd315e15"}[chunkId] + ".chunk.js";
};